import React from "react";
import ControlTemplate from "../BaseControls/ControlTemplate";
import {controlPropTypes} from "../formhelpers";
import PropTypes from "prop-types";

export default class Label extends React.Component {
    render() {
        const {descriptor, value} = this.props;
        const valueStr = ArmusScript["dateFormat(Date,String)"](value, descriptor.config.mask) || "";
        return (
            <ControlTemplate {...this.props} className="datetime-field" >
                <span>{valueStr}</span>
            </ControlTemplate>
        );
    }
}

Label.propTypes = controlPropTypes({
    mask: PropTypes.string.isRequired
});



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/DateTimeField/label.js